<fieldset>
  <legend class="keyLabel">{{ fieldLabel() }}</legend>
  <div class="content">
    @if (response().totalCapacity) {
      <div class="detailRow">
        <label class="displayLabel">Total Capacity:</label>
        <label class="displayValue">{{ response().totalCapacity | number: '1.0-2' }}</label>
        <label class="unitLabel">{{ getCapacityUnits() }}</label>
      </div>
    }
    @if (!isHeat() && response().sensibleCapacity) {
      <div class="detailRow">
        <label class="displayLabel">Sensible Capacity:</label>
        <label class="displayValue">{{ response().sensibleCapacity | number: '1.0-2' }}</label>
        <label class="unitLabel">{{ getCapacityUnits() }}</label>
      </div>
    }
    <div class="detailRow">
      <label class="displayLabel">Dry Bulb:</label>
      <label class="displayValue">{{ response().leavingDryBulb | number: '1.0-2' }}</label>
      <label class="unitLabel">{{ getTemperatureUnits() }}</label>
    </div>
    @if (!isHeat() && response().leavingWetBulb) {
      <div class="detailRow">
        <label class="displayLabel">Wet Bulb:</label>
        <label class="displayValue">{{ response().leavingWetBulb | number: '1.0-2' }}</label>
        <label class="unitLabel">{{ getTemperatureUnits() }}</label>
      </div>
    }
    @if (response().fluidFlowRate) {
      <div class="detailRow">
        <label class="displayLabel">Flow Rate:</label>
        <label class="displayValue">{{ response().fluidFlowRate | number: '1.0-2' }}</label>
        <label class="unitLabel">{{ getFlowRateUnits() }}</label>
      </div>
    }
    @if (response().leavingFluidTemperature) {
      <div class="detailRow">
        <label class="displayLabel">Leaving Fluid Temp:</label>
        <label class="displayValue">{{ response().leavingFluidTemperature | number: '1.0-1' }}</label>
        <label class="unitLabel">{{ getTemperatureUnits() }}</label>
      </div>
    }
  </div>
</fieldset>
